<div *ngIf="!loader">
  <div class="img-wrapper">
    <div class="lable-block">
      <!-- <span class="lable3" *ngIf="product.new">new</span> -->
      <!-- <span class="lable4" *ngIf="product.sale">on sale</span> -->
    </div>
    <div class="front">
      <a [routerLink]="['/shop/product/', product?.id]">
        <img 
          [defaultImage]="ImageSrc ? ImageSrc : 'web/assets/images/product/placeholder.jpg'" 
          [lazyLoad]="ImageSrc ? ImageSrc : product.thumbnail?.imageUrl" 
          class="img-fluid lazy-loading"
          alt="{{ 'alt' }}" />
      </a>
    </div>
    <div class="back" *ngIf="onHowerChangeImage">
      <a [routerLink]="['/shop/product/', product?.id]">
        <img [src]="ImageSrc ? ImageSrc : product.details[1].imageUrl" class="img-fluid lazy-loading" alt="{{ 'product image' }}">
      </a>
    </div>
    <ul class="product-thumb-list" *ngIf="thumbnail">
      <li class="grid_thumb_img" [class.active]="ImageSrc == image.src" *ngFor="let image of product.details">
        <a href="javascript:void(0)" (mouseover)="ChangeVariantsImage(image.imageUrl)">
          <img [lazyLoad]="image.imageUrl">
        </a>
      </li>
    </ul>
  </div>
  <div class="product-detail">
    <div>
      <a [routerLink]="['/shop/product/', product?.id]">
        <h6 style="margin-top: 2%; margin-bottom:0; padding: 0; display: inline-block;">{{ product?.title.toUpperCase() }}</h6>
      </a>
      <div *ngIf="product.variants.length > 0" class="color_float">
        <small style="margin-top: 4%; margin-bottom: 4%;" class="small_text_color_variants">Colori disponibili</small>
        <ul>
          <li *ngFor="let variant of getVariants()" class="margin_color_variants">
            <img class="square_color_size" [src]="variant.color_variant?.imageUrl" />
          </li>
        </ul>
      </div>
      <div>
        <ng-container *ngIf="product.gender_fit != null">
          <small *ngIf="product.gender_fit === 'unisex'">Unisex</small>
          <small *ngIf="product.gender_fit === 'man'">Man</small>
          <small *ngIf="product.gender_fit === 'woman'">Woman</small>
        </ng-container>
        <h4>
          <ng-container *ngIf="product?.old_price != null">
            <span class="old_price_class">€ {{ product?.old_price }}</span>
            <br/>
          </ng-container>
          <span>€ {{ product?.price }}</span>
        </h4>
      </div>
    </div>
  </div>
</div>
<app-skeleton-product-box *ngIf="loader"></app-skeleton-product-box>
<app-quick-view #quickView [product]="product" [currency]="currency"></app-quick-view>
<app-cart-modal #cartModal [product]="product" [currency]="currency" *ngIf="cartModal"></app-cart-modal>

